import React,{useState,useEffect} from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'//yarn add @types/react-router-dom
import {ThemeProvider} from '@mui/material/styles';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import Fab from '@mui/material/Fab';
import useStyles from './Styles';
import {Theme} from './Theme';
import {Inc} from './Inc';
import {Tools} from './Tools';
import Login from './Login';
import Header from './Header';
import SideMenu from './SideMenu';
import Top from './Top';
import First from './First';
import FirstInput from './FirstInput';
import InquiryInput from './InquiryInput';
import InfoList from './InfoList';
import InfoDetail from './InfoDetail';
import NoService from './NoService';
import Oldversion from './Oldversion';
import ItemList from './ItemList';
import ItemDetail from './ItemDetail';
import PageList from './PageList';
import PageDetail from './PageDetail';
import SortItems from './SortItems';
import SaleList from './SaleList';
import LotteryList from './LotteryList';
import ConsignList from './ConsignList';
import ZaikoList from './ZaikoList';
import ZaikoDetail from './ZaikoDetail';
import BookList from './BookList';
import BookDetail from './BookDetail';
import KbinInput from './KbinInput';
import VisitInput from './VisitInput';
import ProfileDetail from './ProfileDetail';
import CustomerDetail from './CustomerDetail';
import BankDetail from './BankDetail';
import BankInput from './BankInput';
import NewsList from './NewsList';
import NewsDetail from './NewsDetail';
import NewsInput from './NewsInput';
import LetterList from './LetterList';
import TakebackList from './TakebackList';
import ReturnList from './ReturnList';
import PlanList from './PlanList';
import PlanInput from './PlanInput';
import SecretList from './SecretList';
import SecretInput from './SecretInput';
import Suspended from './Suspended';
import PaymentDetail from './PaymentDetail';
import Bye from './Bye';
import Mails from './Mails';
import FavList from './FavList';
import RequestList from './RequestList';
import Term from './Term';
import Privacy from './Privacy';
import Law from './Law';
import Company from './Company';
import LogoDownload from './LogoDownload';
import About from './About';
import Sorry from './Sorry';
import Help from './Help';
import Ajax from './Ajax';
import Loading from './Loading';
import PersonMenu from './PersonMenu';
import WrongRix from './WrongRix';
import AppBank from './AppBank';
import { useCookies } from 'react-cookie';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faTumblr } from '@fortawesome/free-brands-svg-icons';
import { faClipboard,faFileDownload,faSmile,faRedo,faLightbulb,faSeedling,faGift,faHeart,faComment,faGem,faCalendarAlt,faTruck,faTheaterMasks,faStar } from '@fortawesome/free-solid-svg-icons';
import {CookieHashName,getCookieOptions} from './Inc';

let cookieValue = ""

const App:React.FC = ()=> {
	const classes = useStyles();
	const [states,setStates] = useState({
		owner: Inc.defaultOwner(),
		param: Inc.defaultOwnerParam(),
		manager_id: 0,
		isDrawerOpen: false,
		isLoading: true,
		isModal: false,
		isNewOwner: false,
		isWrongRix: false,
		isSuspended: false,
		verNewer: "",
		onService: true,
		isPersonMenuOpen: false,
		cache_key: "",
	});
	const [cookies, setCookie, removeCookie] = useCookies(['customer_id']);
	const basename = process.env.REACT_APP_BASENAME;
    //const bank:{ [key: string]: string } = {};

	const bank = new AppBank();

	library.add( faTumblr,faClipboard,faFileDownload,faSmile,faRedo,faLightbulb,faSeedling,faGem,faComment,faGift,faHeart,faCalendarAlt,faTruck,faTheaterMasks,faStar );
	
	const handleDrawerToggle = ()=>{
		setStates({...states,isDrawerOpen:!states.isDrawerOpen});
	};

	const login = (data:any)=>{
		if(!data.customer || !data.customer.customer_id || !data.customer.rix ){
			return;
		}
		//const owner = Tools.convOwner(data,true);
		saveCookie(data);
		setOwner(data);
		//setStates({...states,
		//	manager_id: owner.owner_id,
		//	owner:owner,
		//});
	}

	const logout = ()=>{
		setStates({...states,
			owner:Inc.defaultOwner(),
			isPersonMenuOpen:false
		});
		removeCookie(CookieHashName,getCookieOptions(process.env.REACT_APP_DOMAIN));
		cookieValue = '';
	}

	const retry = ()=>{
		setStates({...states,
			owner:Inc.defaultOwner(),
			isWrongRix: false,
			isPersonMenuOpen:false
		});
		removeCookie(CookieHashName,getCookieOptions(process.env.REACT_APP_DOMAIN));
		cookieValue = '';
	}

	const remove = ()=>{
		setStates({...states,owner:{...states.owner,owner_id:0,owner_name:'',img_id:0},isPersonMenuOpen:false});
	}

	const comissions = ()=>{
		setStates({...states,isPersonMenuOpen:false,isModal:true});
	}

	const openPersonMenu = ()=>{
		if( !states.isPersonMenuOpen ){
			setStates({...states,isPersonMenuOpen:true});
		}
	}

	const closePersonMenu = ()=>{
		if( states.isPersonMenuOpen ){
			setStates({...states,isPersonMenuOpen:false});
		}
	}

	//const handleModalClose = ()=>{
	//	setStates({...states,isModal:false});
	//}
	const handleOldClose = ()=>{
		//setStates({...states,isOld:false});
	}

	const goTop = ()=>{
		window.scrollTo(0,0);
	}

	const menuClick = ()=>{
		if( states.isDrawerOpen ){
			setStates({...states,isDrawerOpen:false});
		}
	}

	//const setBank = (key:string,value:string)=>{
	//	bank[key] = value;
	//}
	//const getBank = (key:string)=>{
	//	return bank[key];
	//}
	//const hasBank = (key:string)=>{
	//	if( key in bank ){
	//		return true;
	//	}
	//	return false;
	//}

	const loadCookie = ()=>{
		let data = {customer_id:0,customer_rix:''};
		let value = '';
		if( cookies[CookieHashName] ){
			value = cookies[CookieHashName];
		} else if( cookieValue!=='' ){
			value = cookieValue;
		}
		if( value!=='' ){
			const lines = value.split(/\n/);
			for( let i=0 ; i<lines.length ; i++ ){
				const sp = lines[i].split(/\t/);
				if( sp[0]==='customer_id' ){
					data.customer_id = parseInt(sp[1]);
				}
				if( sp[0]==='customer_rix' ){
					data.customer_rix = sp[1];
				}
			}
		}
		return data;
	};

	const saveCookie = (data:any)=>{
		cookieValue = "customer_id\t"+data.customer.customer_id+"\ncustomer_rix\t" + data.customer.rix;
		setCookie(CookieHashName,cookieValue,getCookieOptions(process.env.REACT_APP_DOMAIN));
	}

	const refresh = (switch_id:number)=>{
		const cookieData = loadCookie();

		if( !states.owner.isLogined || !states.owner.switch_id || states.owner.switch_id!==switch_id){
			setStates({...states,isLoading:true});
			let customer_id = 0;
			if( cookieData.customer_id ){
				customer_id = cookieData.customer_id;
			}

			Ajax.send("main/owner",{customer_id:customer_id,switch_id:switch_id,rix:cookieData.customer_rix},(res:any)=>{
				if( res.version!==process.env.REACT_APP_VERSION ){
					setStates({...states,verNewer:res.version,isLoading:false});
				} else if( !res.onservice ){
					setStates({...states,onService:false,isLoading:false});
				} else {
					if( res.ok ){
						//console.log("owner",res.owner);
						const owner = Tools.convOwner(res.owner,true);
						const param = Inc.convOwnerParam(res.owner.param);
						let manager_id = states.manager_id;
						if( switch_id===1 ){
							manager_id = owner.owner_id;
						}

						setStates({
							...states,
							manager_id:manager_id,
							owner: owner,
							param: param,
							onService:true,
							cache_key: res.cache_key,
							isLoading:false,
							isSuspended:param.is_suspended,
						});
					} else {
						if( res.reason==="wrong_rix" ){
							setStates({...states, isWrongRix:true, isLoading:false});
						} else if( res.reason==="suspended" ){
							setStates({...states, isSuspended:true, isLoading:false});
						} else {
							setStates({...states, onService:true, cache_key:res.cache_key, isLoading:false});
						}
					}
				}
			});
		}
	}

	const setOwner = (data:any)=>{
		let manager_id = states.manager_id;
		if( data.switch_id===1 && data.owner_id>0 ){
			manager_id = data.owner_id;
		}
		setStates({
			...states,
			manager_id: manager_id,
			owner: Tools.convOwner(data,true),
			//owner:{
			//	owner_id:parseInt(owner.owner_id),
			//	switch_id:parseInt(owner.switch_id),
			//	img_id:parseInt(owner.img_id),
			//	owner_name:owner.owner_name,
			//	customer: owner.customer,
			//	isLogined: true,
			//	high_flag: owner.high_flag,
			//	status: owner.status,
			//},
		})
	}

	const changeOwner = (switch_id:number)=>{
		refresh(switch_id);
	}

	useEffect( ()=>{
		refresh(1);
	},[]);

	if( states.isLoading ){
		//return (null);
		return <Loading isLoading={true}/>
	}

	return (
		<BrowserRouter basename={basename}>
			<ThemeProvider theme={Theme}>
				<Header owner={states.owner} managerId={states.manager_id} onClickDrawer={handleDrawerToggle} onClickPersonMenu={openPersonMenu} changeOwner={changeOwner} comissions={comissions}/>
				<SideMenu owner={states.owner} isOpen={states.isDrawerOpen} onClickMenu={menuClick} onClose={handleDrawerToggle} hide={states.isSuspended}/>
				<div className={classes.main}>
					{!states.isSuspended ? (
					<Switch>
						<Route exact path='/' render={()=><Top owner={states.owner}/>}/>
						<Route exact path='/first' render={()=><First owner={states.owner}/>}/>
						<Route exact path='/first/input' render={()=><FirstInput owner={states.owner}/>}/>
						<Route exact path='/first/p:id' render={()=><First owner={states.owner}/>}/>
						<Route exact path='/help' render={()=><Help/>}/>
						<Route exact path='/help/:helpGroup/:helpId' render={()=><Help/>}/>
						<Route exact path='/kbin' render={()=><KbinInput owner={states.owner}/>}/>
						<Route exact path='/inquiry' render={()=><InquiryInput owner={states.owner}/>}/>
						<Route exact path='/info' render={()=><InfoList/>}/>
						<Route exact path='/info/year/:year' render={()=><InfoList/>}/>
						<Route exact path='/info/:id' render={()=><InfoDetail/>}/>
						<Route exact path='/term' render={()=><Term/>}/>
						<Route exact path='/privacy' render={()=><Privacy/>}/>
						<Route exact path='/law' render={()=><Law/>}/>
						<Route exact path='/logodownload' render={()=><LogoDownload/>}/>
						<Route exact path='/company' render={()=><Company/>}/>
						<Route exact path='/about' render={()=><About/>}/>
						<Route exact path='/sorry' render={()=><Sorry/>}/>
						<Route exact path='/profile' render={()=><ProfileDetail owner={states.owner} param={states.param} setOwner={setOwner}/>}/>
						{states.owner.isLogined ? (
						<Switch>
							<Route exact path='/customer' render={()=><CustomerDetail owner={states.owner}/>}/>
							<Route exact path='/item' render={()=><ItemList owner={states.owner} managerId={states.manager_id} bank={bank}/>}/>
							<Route exact path='/item/:id' render={()=><ItemDetail owner={states.owner} managerId={states.manager_id}/>}/>
							<Route exact path='/page' render={()=><PageList owner={states.owner} managerId={states.manager_id} bank={bank}/>}/>
							<Route exact path='/page/:id' render={()=><PageDetail owner={states.owner} managerId={states.manager_id}/>}/>
							<Route exact path='/sort' render={()=><SortItems owner={states.owner}/>}/>
							<Route exact path='/sale' render={()=><SaleList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/lottery' render={()=><LotteryList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/consign' render={()=><ConsignList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/zaiko' render={()=><ZaikoList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/zaiko/:id' render={()=><ZaikoDetail owner={states.owner}/>}/>
							<Route exact path='/book' render={()=><BookList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/book/:id' render={()=><BookDetail owner={states.owner} cache_key={states.cache_key} managerId={states.manager_id}/>}/>
							<Route exact path='/visit' render={()=><VisitInput owner={states.owner}/>}/>
							<Route exact path='/bank' render={()=><BankDetail owner={states.owner} managerId={states.manager_id}/>}/>
							<Route exact path='/bank/input' render={()=><BankInput owner={states.owner}/>}/>
							<Route exact path='/news' render={()=><NewsList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/news/:id' render={()=><NewsDetail owner={states.owner}/>}/>
							<Route exact path='/news/input/:id' render={()=><NewsInput owner={states.owner}/>}/>
							<Route exact path='/letter' render={()=><LetterList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/takeback' render={()=><TakebackList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/return' render={()=><ReturnList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/plan' render={()=><PlanList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/plan/input' render={()=><PlanInput owner={states.owner}/>}/>
							<Route exact path='/secret' render={()=><SecretList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/secret/input' render={()=><SecretInput owner={states.owner}/>}/>
							<Route exact path='/payment' render={()=><PaymentDetail owner={states.owner} managerId={states.manager_id}/>}/>
							<Route exact path='/fav' render={()=><FavList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/request' render={()=><RequestList owner={states.owner} bank={bank}/>}/>
							<Route exact path='/bye' render={()=><Bye owner={states.owner} remove={remove} logout={logout}/>}/>
							<Route exact path='/mails' render={()=><Mails owner={states.owner}/>}/>
						</Switch>
						):(
						<Switch>
							<Route path='/' render={()=><Login change={login}/>}/>
						</Switch>
						)}
					</Switch>
					):(
						<Suspended owner={states.owner} param={states.param}/>
					)}
					<Fab color="primary" size="small" aria-label="add" style={{position:"fixed",right:"0.5em",bottom:"0.5em",zIndex:1000}} onClick={goTop}>
						<ArrowUpwardIcon/>
					</Fab>
				</div>
				<PersonMenu isOpen={states.isPersonMenuOpen} owner={states.owner} close={closePersonMenu} logout={logout}/>
				<Oldversion close={handleOldClose} latest={states.verNewer} isOpen={states.verNewer!==""}/>
				<NoService isOpen={!states.onService}/>
				<WrongRix isOpen={states.isWrongRix} retry={retry}/>
			</ThemeProvider>
		</BrowserRouter>
	);
}

export default App;
